import { render, staticRenderFns } from "./QuickLinksIcon.vue?vue&type=template&id=cbf73398"
import script from "./QuickLinksIcon.vue?vue&type=script&lang=js"
export * from "./QuickLinksIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports